module.exports = __webpack_public_path__ + "static/media/mockup-home-rest.51e3b10b.png";